import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators,
    getCalendar,
    getCustomNumberOfEndPages,
    getOptionalDaySettings,
} from "page/calendar/store";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
} from "ui/store";
import {
    getBorderOptions,
    getFontOptions,
    getSelectedLayout,
    getSelectedFont,
} from "burde-api-content/store";
import { actionCreators as eventActionCreators } from "event/store";
import CalendarControlsAccordion from "./calendar-controls-accordion";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    optionalDaySettings: getOptionalDaySettings(state),
    activeComponent: getActiveNavigationComponent(state),
    borderOptions: getBorderOptions(state),
    customNumberOfEndPages: getCustomNumberOfEndPages(state),
    calendarLayout: getSelectedLayout(state),
    fontOptions: getFontOptions(state),
    selectedFont: getSelectedFont(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...eventActionCreators,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalendarControlsAccordion);
